const AUTH_SUCCESS = 'auth_success'
const AUTH_FAILURE = 'auth_failure'

const receiveMessage = event => {
	try {
		const json = JSON.parse(event.data)
		window.removeEventListener('message', receiveMessage, false)
	} catch (err) {}
}

const buildIframe = ({ clientId, redirectUri }) => {
	// window.addEventListener('message', receiveMessage, false)

	const iframe = document.createElement('iframe')
	const src = `${
		process.env.REACT_APP_ACCOUNTS_URL
	}/?client_id=${encodeURIComponent(
		clientId
	)}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}`

	iframe.setAttribute('src', src)
	iframe.setAttribute('id', ``)
	iframe.style.border = '0'
	iframe.style.width = '0px'
	iframe.style.height = '0px'
	iframe.style.position = 'fixed'
	iframe.style.top = '0'
	iframe.style.right = '0'
	iframe.style.opacity = '0'
	iframe.style.visibility = 'none'

	document.body.appendChild(iframe)

	return new Promise((resolve, reject) => {
		window.addEventListener(
			'message',
			event => {
				try {
					const json = JSON.parse(event.data)

					if (json.event_name === AUTH_SUCCESS) {
						resolve(AUTH_SUCCESS)
					} else if (json.event_name === AUTH_FAILURE) {
						reject(AUTH_FAILURE)
					}
				} catch (err) {}
			},
			false
		)
	})
}

export { buildIframe }



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/buildIframe.js